let notify = () => {};

/** Wired from `ToastProvider` on mount. Pass `null` on cleanup. */
export function registerApiToastNotifier(fn) {
  notify = fn && typeof fn === "function" ? fn : () => {};
}

export function notifyForbidden(message) {
  notify(message || "You do not have permission for this action.", "warning");
}
